import styles from "./settingsDrawerToggle.module.scss";
import { ToggleLeft, ToggleRight } from "lucide-react";
import { SettingsDrawerEntryWrapper } from "./SettingsDrawerEntryWrapper";

export const SettingsDrawerToggle = ({
  onToggle,
  value,
  onText,
  offText,
  ...rest
}) => {
  const content = (
    <div onClick={onToggle} className={styles["toggle"]}>
      {value ? (
        <>
          <ToggleRight className={styles["good"]} />
          {onText}
        </>
      ) : (
        <>
          <ToggleLeft className={styles["bad"]} />
          {offText}
        </>
      )}
    </div>
  );
  return (
    <SettingsDrawerEntryWrapper {...rest}>{content}</SettingsDrawerEntryWrapper>
  );
};
